import Layout from '@/page/index/'
export default [{
  path: '/wel',
  component: Layout,
  redirect: '/wel/index',
  children: [{
    path: 'index',
    name: '首页',
    component: () =>
      import( /* webpackChunkName: "views" */ '@/page/wel')
  }]
}, {
  path: '/info',
  component: Layout,
  redirect: '/info/index',
  children: [{
    path: 'index',
    name: '个人信息',
    component: () =>
      import( /* webpackChunkName: "page" */ '@/views/admin/user/info'),
  }]
}, {
  path: '/',
  component: Layout,
  children: [{
    path: 'post/circle/detail/:id',
    name: '圈子详情',
    component: () =>
      import('@/views/post/circle/detail')
  }, {
    path: 'post/circle/add',
    name: '创建圈子',
    component: () =>
      import('@/views/post/circle/add')
  }, {
    path: 'post/circle/edit/:id',
    name: '编辑圈子',
    component: () =>
      import('@/views/post/circle/detail')
  }, {
    path: 'post/circle/post/add',
    name: '新增帖子',
    component: () =>
      import('@/views/post/circle/post/add')
  }, {
    path: 'post/circle/post/edit',
    name: '编辑帖子',
    component: () =>
      import('@/views/post/circle/post/add')
  },{
    path: 'post/essay/detail/:id',
    name: '文章详情',
    component: () =>
      import('@/views/post/essay/detail')
  }, {
    path: 'upms/member/detail/:id',
    name: '用户详情',
    component: () =>
      import('@/views/member/info/detail')
  },  {
    path: 'upms/member/edit/:id',
    name: '用户编辑',
    component: () =>
      import('@/views/member/info/detail')
  }, {
    path: 'upms/member/official/detail/:id',
    name: '官方号详情',
    component: () =>
      import('@/views/member/official/detail')
  }, {
    path: 'upms/member/official/edit/:id',
    name: '官方号编辑',
    component: () =>
      import('@/views/member/official/detail')
  }, {
    path: 'upms/member/add',
    name: '新增官方号',
    component: () =>
      import('@/views/member/official/add')
  }, {
    path: 'member/organization-tag/detail/:tagId',
    name: '用户列表',
    component: () =>
      import('@/views/member/organization-tag/detail')
  }, {
    path: 'upms/member/tier/add',
    name: '新增等级',
    component: () =>
      import('@/views/member/tier/add')
  }, {
    path: 'upms/member/tier/edit/:tierId',
    name: '编辑等级',
    component: () =>
      import('@/views/member/tier/add')
  }, {
    path: 'post/column/detail/:id',
    name: '专栏详情',
    component: () =>
      import('@/views/post/column/detail')
  },{
    path: 'post/posts/detail/:id',
    name: '帖子详情',
    component: () =>
      import('@/views/post/posts/detail')
  },{
    path: 'post/posts/add',
    name: '发布帖子',
    component: () =>
      import('@/views/post/posts/add')
  },{
    path: 'post/posts/edit',
    name: '编辑帖子',
    component: () =>
      import('@/views/post/posts/add')
  },{
    path: 'news/news/detail/:id',
    name: '资讯详情',
    component: () =>
      import('@/views/news/news/detail')
  },{
    path: 'news/source/detail/:id',
    name: '来源详情',
    component: () =>
      import('@/views/news/source/detail')
  },{
    path: 'news/news/publish',
    name: '发布资讯',
    component: () =>
      import('@/views/news/news/publish')
  }, {
    path: 'setting/template/post/detail/:id',
    name: '帖子模板详情',
    component: () =>
      import('@/views/setting/template/post/detail')
  }, {
    path: 'setting/template/post/edit/:id',
    name: '编辑帖子模板',
    component: () =>
      import('@/views/setting/template/post/detail')
  }, {
    path: 'setting/template/post/add',
    name: '创建帖子模板',
    component: () =>
      import('@/views/setting/template/post/add')
  }, {
    path: 'setting/template/message/detail/:id',
    name: '常见问题详情',
    component: () =>
      import('@/views/setting/template/message/detail')
  }, {
    path: 'setting/template/message/edit/:id',
    name: '编辑常见问题',
    component: () =>
      import('@/views/setting/template/message/detail')
  }, {
    path: 'setting/template/message/add',
    name: '创建常见问题',
    component: () =>
      import('@/views/setting/template/message/add')
  }, {
    path: 'post/comment/:id',
    name: '评论详情',
    component: () => import('@/views/post/comment/detail'),
  },{
    path: 'post/essay/add',
    name: '创建文章',
    component: () =>
      import('@/views/post/essay/add')
  },{
    path: 'post/essay/edit',
    name: '编辑文章',
    component: () =>
      import('@/views/post/essay/add')
  },{
    path: 'radar/comment/detail/:id',
    name: '评论详情',
    component: () =>
      import('@/views/radar/comment/detail')
  },{
    path: 'basicpage/detail/:id',
    name: '网页素材详情',
    component: () =>
      import('@/views/setting/basicpage/detail')
  },{
    path: 'basicpage/add',
    name: '网页素材添加',
    component: () =>
      import('@/views/setting/basicpage/add')
  },{
    path: 'basicpage/edit',
    name: '网页素材编辑',
    component: () =>
      import('@/views/setting/basicpage/add')
  },{
    path: 'basicpage/list',
    name: '网页素材列表',
    component: () =>
      import('@/views/setting/basicpage/index')
  },{
    path: '/content/list/detail/:id',
    name: '内容详情',
    component: () =>
      import('@/views/content/list/detail')
  },{
    path: '/content/list/edit',
    name: '内容编辑',
    component: () =>
      import('@/views/content/list/add')
  },{
    path: '/content/list/add',
    name: '新建内容',
    component: () =>
      import('@/views/content/list/add')
  }, {
    path: '/msg/notice/add',
    name: '创建消息',
    component: () =>
      import('@/views/msg/notice/add')
  }, {
    path: '/content/topic/add',
    name: '新增话题',
    component: () =>
      import('@/views/content/topic/add')
  }, {
    path: '/content/classification/add',
    name: '新增分类',
    component: () =>
    import('@/views/content/classification/add')
  }, {
    path: '/app/activity/add',
    name: '新增培训',
    component: () =>
    import('@/views/app/activity/list/add')
  }, {
    path: '/app/activity/edit/:id',
    name: '编辑培训',
    component: () =>
    import('@/views/app/activity/list/add')
  },{
    path: 'app/activity/detail/:id',
    name: '培训详情',
    component: () =>
      import('@/views/app/activity/list/detail')
  } ,{
    path: 'app/activity/type/add',
    name: '新增培训类型',
    component: () =>
      import('@/views/app/activity/type/add')
  }, {
    path: 'app/activity/type/edit/:id',
    name: '编辑培训类型',
    component: () =>
      import('@/views/app/activity/type/add')
  }, {
    path: 'app/vote/add',
    name: '新增投票',
    component: () =>
      import('@/views/app/vote/add')
  }, {
    path: 'app/vote/edit/:id',
    name: '编辑投票',
    component: () =>
      import('@/views/app/vote/add')
  }, {
    path: 'app/vote/detail/:id',
    name: '投票详情',
    component: () =>
      import('@/views/app/vote/detail')
  }, {
    path: 'app/questionnaire/add',
    name: '新增问卷',
    component: () =>
      import('@/views/app/questionnaire/add')
  }, {
    path: 'app/questionnaire/edit/:id',
    name: '编辑问卷',
    component: () =>
      import('@/views/app/questionnaire/add')
  }, {
    path: 'app/questionnaire/detail/:id',
    name: '问卷详情',
    component: () =>
      import('@/views/app/questionnaire/detail')
  }, {
    path: 'app/config/add',
    name: '新增应用配置',
    component: () =>
      import('@/views/app/config/add')
  }, {
    path: 'app/config/edit/:id',
    name: '编辑应用配置',
    component: () =>
      import('@/views/app/config/add')
  }, {
    path: 'app/exam/subject-lib/add',
    name: '新增题库',
    component: () =>
      import('@/views/app/exam/subject-lib/add')
  }, {
    path: 'app/exam/subject-lib/edit/:id',
    name: '编辑题库',
    component: () =>
      import('@/views/app/exam/subject-lib/add')
  }, {
    path: 'app/exam/paper/add',
    name: '新增试卷',
    component: () =>
      import('@/views/app/exam/paper/add')
  }, {
    path: 'app/exam/paper/edit/:id',
    name: '编辑试卷',
    component: () =>
      import('@/views/app/exam/paper/add')
  }, {
    path: 'app/exam/paper/show/:id',
    name: '查看试卷',
    component: () =>
      import('@/views/app/exam/paper/show')
  }, {
    path: 'app/exam/exam/add',
    name: '新增考试',
    component: () =>
      import('@/views/app/exam/exam/add')
  }, {
    path: 'app/exam/exam/edit/:id',
    name: '编辑考试',
    component: () =>
      import('@/views/app/exam/exam/add')
  }, 
  {
    path: 'app/exam/exam/detail/:id',
    name: '查看考试',
    component: () =>
      import('@/views/app/exam/exam/detail')
  }, 
  {
    path: 'analysis/ranking/detail',
    name: '排行榜详情',
    component: () =>
      import('@/views/analysis/ranking/detail')
  },{
    path: '/mall/goods/detail/:id',
    name: '商品详情',
    component: () =>
      import('@/views/mall/goods/detail')
  },{
    path: '/mall/goods/edit/:id',
    name: '商品编辑',
    component: () =>
      import('@/views/mall/goods/add')
  },{
    path: '/mall/goods/add',
    name: '新建商品',
    component: () =>
      import('@/views/mall/goods/add')
  },{
    path: '/mall/record/detail/:id',
    name: '商品兑换详情',
    component: () =>
      import('@/views/mall/record/detail')
  },{
    path: '/reward/medal/detail/:id',
    name: '勋章详情',
    component: () =>
      import('@/views/reward/medal/detail')
  },{
    path: '/reward/medal/edit/:id',
    name: '勋章编辑',
    component: () =>
      import('@/views/reward/medal/add')
  },{
    path: '/reward/medal/add',
    name: '新建勋章',
    component: () =>
      import('@/views/reward/medal/add')
  },{
    path: 'app/course/courseware/add',
    name: '新增课件',
    component: () =>
      import('@/views/app/course/courseware/add')
  },{
    path: 'app/course/courseware/edit/:id',
    name: '编辑课件',
    component: () =>
      import('@/views/app/course/courseware/add')
  },{
    path: 'app/course/courseware/:id',
    name: '课件详情',
    component: () =>
      import('@/views/app/course/courseware/detail')
  },{
    path: 'app/course/course/add',
    name: '新增课程',
    component: () =>
      import('@/views/app/course/course/add')
  },{
    path: 'app/course/course/edit/:id',
    name: '编辑课程',
    component: () =>
      import('@/views/app/course/course/add')
  },{
    path: 'app/course/detail/:id',
    name: '课程详情',
    component: () =>
      import('@/views/app/course/course/detail')
  },{
    path: 'app/course/course-courseware/:id',
    name: '课时详情',
    component: () =>
      import('@/views/app/course/course-courseware/detail')
  },{
    path: 'app/course/course-courseware-post/:id',
    name: '留言详情',
    component: () =>
      import('@/views/app/course/course-courseware-post/detail')
  }]
}, {
  path: '/star',
  component: Layout,
  children: [{
    path: '/star/activity/staff',
    name: '员工赛事信息管理',
    component: () => import('@/views/activity/staff')
  }, {
    path: '/star/activity/tree',
    name: '赛事统计_种树活动',
    component: () => import('@/views/activity/tree')
  }, {
    path: '/star/activity/restaurant',
    name: '赛事记录_餐厅比拼',
    component: () => import('@/views/activity/restaurant')
  }, {
    path: '/star/activity/restaurant-statistics',
    name: '赛事统计_餐厅比拼',
    component: () => import('@/views/activity/restaurant-statistics')
  }, {
    path: '/star/activity/online-pk-statistics',
    name: '荣耀王者PK赛_赛事统计',
    component: () => import('@/views/activity/online-pk-statistics')
  }, {
    path: '/star/activity/staff-online-pk-statistics',
    name: '荣耀王者PK赛_员工赛事记录',
    component: () => import('@/views/activity/staff-online-pk-statistics')
  }]
},{
  path: '/manager-contest',
  component: Layout,
  children: [{
    path: '/manager-contest/spaceship',
    name: '启动日报告_航天站助力统计',
    component: () => import('@/views/manager-contest/spaceship')
  }, {
    path: '/manager-contest/spaceship-record',
    name: '启动日报告_航天站助力记录',
    component: () => import('@/views/manager-contest/spaceship-record')
  },{
    path: '/manager-contest/store-contest-record',
    name: '赛事记录_餐厅比拼',
    component: () => import('@/views/manager-contest/store-contest-record')
  },{
    path: '/manager-contest/store-contest-statistics',
    name: '赛事统计_餐厅比拼',
    component: () => import('@/views/manager-contest/store-contest-statistics')
  },  {
    path: '/manager-contest/online-pk-record',
    name: '荣耀王者PK赛_员工赛事记录',
    component: () => import('@/views/manager-contest/online-pk-record')
  },{
    path: '/manager-contest/online-pk-statistics',
    name: '荣耀王者PK赛_赛事统计',
    component: () => import('@/views/manager-contest/online-pk-statistics')
  }]
}]
